import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useNoSearchResultsStyles = makeStyles({
    root: {
        fontSize: tokens.fontSizeHero700,
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        height: '100px',
        ...shorthands.border('5px', 'solid', tokens.colorNeutralStroke2),
        ...shorthands.borderRadius(tokens.borderRadiusXLarge)
    },
    text: {
        display: 'grid',
        height: '100%',
        alignItems: 'center',
        color: tokens.colorNeutralStroke1
    }
});

export default useNoSearchResultsStyles;
